import { Container } from './styles'
import reactIcon from '../../assets/react-icon.svg'
import linkedin from '../../assets/linkedin.svg'
import githubIcon from '../../assets/github.svg'

export function Footer() {
  return (
    <Container className="footer">
      <a href="https://mehersultana.com" className="logo">
        Meher Sultana
      </a>
      <div>
        <p>
          Built with <img src={reactIcon} alt="React" /> React
        </p>
      </div>
      <div className="social-media">
        <a
          href="https://www.linkedin.com/in/meher-s-r46/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={linkedin} alt="Linkedin" />
        </a>
        <a
          href="https://github.com/MeherSultana"
          target="_blank"
          rel="noreferrer"
        >
          <img src={githubIcon} alt="GitHub" />
        </a>
      </div>
    </Container>
  )
}
